<h2 mat-dialog-title><mat-icon>local_shipping</mat-icon> Новый поставщик</h2>
<form [formGroup]="form" (ngSubmit)="save()" [attr.aria-busy]="saving">
  <mat-dialog-content>
    <p class="info">Укажите название поставщика. Остальные реквизиты можно заполнить позже.</p>
    <div class="fields">
      <mat-form-field appearance="outline" floatLabel="always" class="wide">
        <mat-label>Название</mat-label>
        <input matInput formControlName="description" maxlength="255" autocomplete="off" required />
        <mat-error>Укажите название поставщика</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always" class="wide">
        <mat-label>Полное название</mat-label>
        <input matInput formControlName="fullDescription" maxlength="255" autocomplete="off" />
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>ИНН</mat-label>
        <input matInput formControlName="taxNum" maxlength="255" autocomplete="off" />
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>ОКПО</mat-label>
        <input matInput formControlName="orgNum" maxlength="255" autocomplete="off" />
      </mat-form-field>
    </div>
    <p *ngIf="error" class="error" role="alert">{{ error }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" mat-dialog-close [disabled]="saving">Отмена</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="saving || form.invalid">
      <mat-spinner *ngIf="saving" diameter="18" strokeWidth="2"></mat-spinner>
      <mat-icon *ngIf="!saving">add</mat-icon>
      {{ saving ? 'Создаём…' : 'Создать поставщика' }}
    </button>
  </mat-dialog-actions>
</form>
